import React from "react";

export const GlassesIcon = ({ size = 56, stroke = "#f5f3ef", strokeWidth = 2, className = "" }) => (
  <svg
    width={size}
    height={size * (60 / 200)}
    viewBox="0 0 200 60"
    className={className}
    fill="none"
    stroke={stroke}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="55" cy="30" r="22" />
    <circle cx="145" cy="30" r="22" />
    <path d="M77 30 L123 30" />
    <path d="M16 22 L33 30" />
    <path d="M184 22 L167 30" />
  </svg>
);

export default GlassesIcon;
